/// <amd-module name="Wit/BoardsHub/Common/IBoardsDirectoryService" />
import { Services } from "VSS/Platform/Context";
import { DirectoryService, IDirectoryService } from "Wit/DirectoryService/IDirectoryService";

namespace DataProviders {
    export const AllDirectoryDataProvider = "ms.vss-work-web.boards-directory-all-data-provider";
    export const DirectoryDataProvider = "ms.vss-work-web.boards-directory-data-provider";
}

export interface IBoardsDirectoryService extends IDirectoryService {}

class BoardsDirectoryService extends DirectoryService implements IBoardsDirectoryService {
    protected myDirectoryDataProviderContribution = DataProviders.DirectoryDataProvider;
    protected allDirectoryDataProviderContribution = DataProviders.AllDirectoryDataProvider;
}

Services.add("IBoardsDirectoryService", { serviceFactory: BoardsDirectoryService });
